import { PAGE_SIZES } from '../constants';

const fromQueryParams = ({page, pageSize}) => {
  const pageParams = {};
  const parsedPage = parseInt(page);

  if (parsedPage && parsedPage > 0) {
    pageParams.page = parsedPage;
  }

  if (PAGE_SIZES.includes(pageSize)) {
    pageParams.perPage = pageSize;
  }

  return pageParams;
};

export const dataMappers = {
  fromQueryParams
};
